import apiClient from '../../shared/services/apiClient';

/**
 * 统一开通向导服务:选地区 → 选套餐(后端按地区有在线节点的地区/套餐返回)。
 * 加购走 cartService.addItem({ product_type, product_id, billing_cycle, region, config })。
 */
const provisionService = {
    /** 某产品类型当前有可用节点的地区 */
    getRegions: async (productType) => {
        const res = await apiClient.get('/api/user/provision/regions', { params: { product_type: productType } });
        return res.data;
    },

    /** 某地区某产品类型的可售套餐(含定价 + 规格特性) */
    getPlans: async (productType, region) => {
        const res = await apiClient.get('/api/user/provision/plans', { params: { product_type: productType, region } });
        return res.data;
    },
};

export default provisionService;
